<template>
  <div class="video-grid" id="video">
    <div class="recording-status">
      <span
        class="recording-circle"
        :style="{
          backgroundColor: recordStatus.color
        }"
      ></span>
      <span
        :style="{
          color: recordStatus.color
        }"
       class="recording-text">{{
        recordStatus.text
       }}</span>
    </div>
    <div v-show="isDoubleCamera" class="two-camera">
      <div @click="isShowMini = false" class="desktop-camera">
        <ComputerIcon :color="isShowMini ? '#9A9A9A' : undefined" />
        <span
          :style="{
            color: isShowMini ? '#9A9A9A' : '#2F54EB'
          }"
          >电脑摄像头</span
        >
      </div>
      <div @click="handleMiniTabClick" class="mini-camera">
        <CellPhoneIcon :color="miniTabColor" />
        <span
          :style="{
            color: miniTabColor
          }"
          >
            手机摄像头
        </span>
      </div>
    </div>
    <div class="video-view">
      <div id="localStream" class="video-placeholder"></div>
      <canvas
        style="display: none"
        id="canvasAgoraCamera"
        :width="photoWidth"
        :height="photoHeight"
      ></canvas>
    </div>
    <p
      class="text"
      :class="{
        'hover-show': !isShowMini || !isMiniOnline
      }"
      @click="changeVideo"
      :style="{
        background: `${hexToRgba($store.state.theme.themeColor, 0.8)}`
      }"
    >
      <icon-camera class="icon-camera"></icon-camera>点击切换摄像头
    </p>
    <div v-if="loading" class="loading">
      <looping-rhombuses-spinner
        :animation-duration="2500"
        :rhombus-size="20"
        :color="$store.state.theme.themeColor.split(';')[0]"
      />
    </div>
    <div
      :style="{
        visibility: isShowMini && isMiniOnline ? 'visible' : 'hidden',
        zIndex: isMiniOnline ? 1 : 0
      }"
      v-if="isDoubleCamera"
      id="mini-video-player"
      class="mini-video-player"
    ></div>
    <MiniCameraOfflieModal ref="miniCameraOfflineModal" />
  </div>
</template>

<script>
import AgoraRtcTool from '@/utils/AgoraRtcHelper'
import { sleep, getExamId } from '@/utils'
import IconCamera from '@/assets/svg/icon-camera-change.svg'
import cameraErrorTips from './cameraErrorTips.json'
import LoopingRhombusesSpinner from 'epic-spinners/src/components/lib/LoopingRhombusesSpinner'
import {
  getDefaultCameraId,
  setDefaultCameraId
} from '@/views/Detect/pc/helper/deviceDetect.helper'
import {
  getAgoraToken,
  getAgoraTokenWithUniqueUID,
  startExamRecording,
  // getExamRecordingInfos,
  stopExamRecording
} from '@/apis/agora.api'
import ComputerIcon from './ComputerIcon.vue'
import CellPhoneIcon from './CellPhoneIcon.vue'
import MiniCameraOfflieModal from './MiniCameraOfflieModal.vue'

export default {
  components: {
    IconCamera,
    LoopingRhombusesSpinner,
    ComputerIcon,
    CellPhoneIcon,
    MiniCameraOfflieModal
  },
  props: {
    userId: {
      type: Number
    },
    openPhotoMonitor: {
      type: Boolean
    },
    isDoubleCamera: {
      type: Boolean
    },
    isKeepRecord: {
      type: Boolean
    }
  },
  data() {
    return {
      examId: null,
      pcMointorKey: null,
      miniMonitorKey: null,
      statusTimer: null,
      agoraInfo: {},
      agoraStatus: {},
      errorTimes: 0,
      photoWidth: 420,
      photoHeight: 280,
      photoTimer: null,
      videoStatusTimer: null,
      getRecordTimer: null,
      isPcPublish: false,
      videos: [],
      audios: [],
      videoId: null,
      audioId: null,
      showDeviceSelect: false,
      videoIndex: 0,
      loading: false,
      isShowMini: false,
      isMiniOnline: false,
      miniRecordInfo: null,
      pcRecordInfo: null
    }
  },
  mounted() {
    this.examId = this.$route.query.examId || getExamId()
    this.pcMointorKey = `pc-${this.userId}-${this.examId}`
    this.miniMonitorKey = `mini-${this.userId}-${this.examId}`

    this.initPcChannel()

    if (this.isDoubleCamera) {
      this.initMiniChannel()
    }
  },
  async destroyed() {
    await this.leavePc()
    if (this.isDoubleCamera) {
      await this.leaveMini()
    }
  },
  watch: {

    isDoubleCamera(newVal) {
      // isDoubleCamera更新后会影响本地视频的播放，所以需要重新播放
      const clientHelper = AgoraRtcTool.getClient(this.pcMointorKey)
      if (clientHelper) {
        setTimeout(() => {
          clientHelper.playLocalVideo('localStream')
        }, 200)
      }

      if (newVal) {
        this.initMiniChannel()
      } else {
        this.leaveMini()
      }
    },
    isKeepRecord(newVal) {
      if (!newVal) {
        this.stopRecording(1)
        this.stopRecording(2)
      }
    }
  },
  methods: {

    async initPcChannel() {
      try {
        const examId = this.examId
        const userId = this.userId
        const data = await getAgoraTokenWithUniqueUID({
          userId,
          examId,
          type: 1,
          TIME: new Date().getTime()
        })

        await this.getDevices()
        AgoraRtcTool.initClient(this.pcMointorKey, {
          appId: data.appId,
          channel: data.channel,
          token: data.token,
          uid: data.uid
        })
        const clientHelper = AgoraRtcTool.getClient(this.pcMointorKey)
        if (clientHelper) {
          await clientHelper.join()
          await clientHelper.pulish({
            cameraId: this.videoId
          })
          this.isPcPublish = true
          clientHelper.playLocalVideo('localStream')
          this.startRecording(1)
          clientHelper.listenTokenWillExpire(async () => {
            const newToken = await getAgoraTokenWithUniqueUID({
              userId: this.userId,
              examId: this.examId,
              type: 1,
              TIME: new Date().getTime()
            })
            await clientHelper.renewToken(newToken.token)
          })
          clientHelper.listenTokenExpired(async () => {
            console.error('pc token expired')
          })
        }
      } catch (error) {
        console.log('initPcChannel', error)
        this.$message.error('开启电脑录制失败')
      }
    },

    async initMiniChannel() {
      try {
        const examId = this.examId
        const userId = this.userId
        const data = await getAgoraToken({
          userId,
          examId,
          type: 2,
          TIME: new Date().getTime()
        })

        const client = AgoraRtcTool.initClient(this.miniMonitorKey, {
          appId: data.appId,
          channel: data.channel,
          token: data.token,
          uid: data.uid,
          isHost: false
        })
        client.listenVideoPublish((_, mediaType) => {
          if (mediaType !== 'video') {
            return
          }
          this.isMiniOnline = true
          // 远端开始推流，开始录制
          this.startRecording(2)
          this.$refs.miniCameraOfflineModal.close()
        })
        client.listenVideoUnpublish((_, mediaType) => {
          if (mediaType !== 'video') {
            return
          }
          this.isMiniOnline = false
          this.$refs.miniCameraOfflineModal.open()
        })
        client.listenTokenWillExpire(async () => {
          const newToken = await getAgoraToken({
            userId: this.userId,
            examId: this.examId,
            type: 2,
            uid: data.uid,
            TIME: new Date().getTime()
          })
          await client.renewToken(newToken.token)
        })
        client.listenTokenExpired(async () => {
          console.error('mini token expired')
        })
        // 2s 后检查是否有远端视频
        setTimeout(() => {
          if (!client.hasRemoteVideo()) {
            this.isMiniOnline = false
            this.$refs.miniCameraOfflineModal.open()
          }
        }, 2000)

        client.playRemoteVideo('mini-video-player')
        await client.join()
      } catch (error) {
        console.log('initMiniChannel', error)
        this.$message.error('开启手机录制失败')
      }
    },

    /**
     * 开始录制
     * @param type 1: pc 2: mini
     */
    async startRecording(type) {
      // 没有开启全程录制
      if (!this.isKeepRecord) {
        return
      }

      const _startExamRecording = async () => {
        startExamRecording({
          userId: this.userId,
          examId: this.examId,
          type
        })
          .then(async (recordInfo) => {
            if (recordInfo.sid && recordInfo.resourceId) {
              if (type === 1) {
                this.pcRecordInfo = recordInfo
              } else {
                this.miniRecordInfo = recordInfo
              }
              // const _getExamRecordingInfos = async () => {
              //   getExamRecordingInfos({
              //     examId: this.examId,
              //     userId: this.userId,
              //     type,
              //     recordUid: recordInfo.recordUid,
              //     channel: recordInfo.channel,
              //     resourceId: recordInfo.resourceId,
              //     sid: recordInfo.sid
              //   }).then(async(res) => {
              //     if (!res.fileList) {
              //       await sleep(15000)
              //       _getExamRecordingInfos()
              //     }
              //   }).catch(async () => {
              //     await sleep(15000)
              //     _getExamRecordingInfos()
              //   })
              // }
              // _getExamRecordingInfos()
            } else {
              await sleep(5000)
              _startExamRecording()
            }
          }).catch(async() => {
            await sleep(5000)
            _startExamRecording()
          })
      }
      _startExamRecording()
    },

    async stopRecording(type) {
      // 没有开启全程录制
      if (!this.isKeepRecord && !this.pcRecordInfo && !this.miniRecordInfo) {
        return
      }

      if (type === 1 && this.pcRecordInfo) {
        await stopExamRecording({
          channel: this.pcRecordInfo.channel,
          recordUid: this.pcRecordInfo.recordUid,
          resourceId: this.pcRecordInfo.resourceId,
          sid: this.pcRecordInfo.sid
        })
        this.pcRecordInfo = null
      } else if (type === 2 && this.miniRecordInfo) {
        await stopExamRecording({
          channel: this.miniRecordInfo.channel,
          recordUid: this.miniRecordInfo.recordUid,
          resourceId: this.miniRecordInfo.resourceId,
          sid: this.miniRecordInfo.sid
        })
        this.miniRecordInfo = null
      }
    },

    // 断开流
    async leavePc() {
      const client = AgoraRtcTool.getClient(this.pcMointorKey)
      if (!client) {
        return
      }
      await this.stopRecording(1)
      await client.destroy()
    },
    // 离开手机端监控
    async leaveMini() {
      const client = AgoraRtcTool.getClient(this.miniMonitorKey)
      if (!client) {
        return
      }
      await this.stopRecording(2)
      await client.destroy()
    },
    // 获取摄像头列表
    async getDevices() {
      const _this = this
      try {
        const { cameras: camreaList } = await AgoraRtcTool.getDevices({
          video: true,
          audio: false
        })
        _this.videos = camreaList.map((item, idx) => {
          return {
            name: item.label || `camera-${idx + 1}`,
            value: item.deviceId,
            kind: item.kind
          }
        })
        const defaultCameraId = getDefaultCameraId() || _this.videos[0].value
        _this.videoId = defaultCameraId
        setDefaultCameraId(defaultCameraId)
      } catch (error) {
        console.log('getDevices', error)
        this.$message.error('获取摄像头失败')
      }
    },
    async changeVideo() {
      // 切换摄像头
      const len = this.videos.length
      if (len === 1) {
        this.$message.warning('只有一个摄像头，无法切换')
        return
      }
      this.loading = true
      this.videoIndex++
      if (this.videoIndex >= len) {
        this.videoIndex = 0
      }
      this.videoId = this.videos[this.videoIndex].value
      setDefaultCameraId(this.videoId)
      const client = AgoraRtcTool.getClient(this.pcMointorKey)
      if (!client) {
        this.loading = false
        return
      }
      client
        .switchVideoDevice(this.videoId)
        .then(() => {
          this.$message.success('切换摄像头成功')
          localStorage.setItem('videoIndex', this.videoIndex)
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          const msg = cameraErrorTips[error]
          this.$message.error(`切换摄像头失败，${msg}`)
        })
    },
    handleMiniTabClick() {
      if (!this.isMiniOnline) {
        this.$refs.miniCameraOfflineModal.open()
      } else {
        this.isShowMini = true
      }
    },
    hexToRgba(hex, opacity) {
      return (
        'rgba(' +
        parseInt('0x' + hex.slice(1, 3)) +
        ',' +
        parseInt('0x' + hex.slice(3, 5)) +
        ',' +
        parseInt('0x' + hex.slice(5, 7)) +
        ',' +
        opacity +
        ')'
      )
    },
    async leave() {
      await this.leavePc()
      if (this.isDoubleCamera) {
        await this.leaveMini()
      }
    }
  },
  computed: {
    miniTabColor() {
      if (!this.isMiniOnline) {
        return '#F5222D'
      }

      return this.isShowMini ? '#2F54EB' : '#9A9A9A'
    },
    recordStatus() {
      if (this.isShowMini && this.isMiniOnline) {
        return {
          text: '手机正在录制中',
          color: '#73d13d'
        }
      } else if (this.isShowMini && !this.isMiniOnline) {
        return {
          text: '手机摄像头未连接',
          color: '#F5222D'
        }
      } else if (!this.isShowMini && this.isPcPublish) {
        return {
          text: '电脑正在录制中',
          color: '#73d13d'
        }
      } else {
        return {
          text: '电脑摄像头未连接',
          color: '#F5222D'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.video-placeholder {
  position: relative;
  width: 240px;
  height: 160px;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
}

.video-grid {
  position: relative;
  border-radius: 8px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;

  &:hover {
    .hover-show {
      visibility: visible;
      opacity: 1;
      z-index: 1;
    }
  }
}

.text {
  display: flex;
  align-items: center;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 32px;
  // background: rgba(51, 51, 51, 0.8);
  border-radius: 0 0 8px 8px;
  color: #fff;
  font-size: 14px;
  padding-left: 10px;
  visibility: hidden;
  opacity: 0;
  transition: all 0.3s;

  .icon-camera {
    display: inline-block;
    margin-right: 8px;
  }
}

.loading {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  background: rgba(0, 0, 0, 0.4);
}

.mini-video-player {
  width: 240px;
  height: 160px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 8px;
  background-color: transparent;
  overflow: hidden;
}

.recording-status {
  padding: 8px 15px;
  border-bottom: 1px solid #0000000f;

  .recording-circle {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #73d13d;
    display: inline-block;
    margin-right: 7px;
  }

  .recording-text {
    font-size: 12px;
    color: #73d13d;
  }
}

.two-camera {
  display: flex;
  justify-content: space-between;

  span {
    font-size: 12px;
    color: #000000d9;
    margin-left: 5px;
  }

  .desktop-camera,
  .mini-camera {
    display: flex;
    align-items: center;
    width: 50%;
    padding: 7px 15px;
    cursor: pointer;
  }

  .desktop-camera:hover,
  .mini-camera:hover {
    background: #f5f5f5;
  }

  .desktop-camera:active,
  .mini-camera:active {
    background: #e5e5e5;
  }
}
.video-view {
  z-index: 1;
}
</style>
